import React from 'react'
import Overview from 'components/insightContent/visualization/Overview'
import { InsightContentSettingType } from 'components/insightContent/types'
import UnexpectedErrorBoundary from 'components/UnexpectedErrorBoundary'
import useCrosstabData from 'components/widget/CrosstabWidgets/share/Crosstab/useCrosstabData'
import Title from './Title'
import resolveSum from '../utils/sumResolver'
import selectEntireColumn from '../utils/columnSelector'
import selectEntireRow from '../utils/rowSelector'
import resolveShare from '../utils/shareResolver'

const ShareOfColumns = ({
  detailSetting,
  widgetId,
  isAudienceQuery
}: {
  detailSetting: InsightContentSettingType
  widgetId: number
  isAudienceQuery: boolean
}) => {
  const { crossTabs } = useCrosstabData(widgetId, isAudienceQuery)

  const selectedColumn = selectEntireColumn(detailSetting, crossTabs)
  const selectedItem = selectEntireRow(detailSetting, selectedColumn)

  const sumOfSelectedColumn = resolveSum(selectedColumn)
  const selectedItemValue = resolveSum(selectedItem)

  return (
    <UnexpectedErrorBoundary>
      <Overview
        title={<Title />}
        count={resolveShare(sumOfSelectedColumn, selectedItemValue)}
        status="succeeded"
      />
    </UnexpectedErrorBoundary>
  )
}

export default ShareOfColumns
